/**
 * `reservation.salesPerson` is one string, written as `"<email> (<name>)"` by the create
 * form and the source/channel modal. Older reservations can hold just a name or just an
 * email, so whatever is not in that shape is kept as whichever half it looks like.
 */
export const parseSalesPerson = (
  salesPerson?: string
): { name?: string; email?: string } | undefined => {
  const value = salesPerson?.trim();
  if (!value) return undefined;

  const match = value.match(/^(\S+@\S+)\s*\((.+)\)$/);
  if (match) return { email: match[1], name: match[2].trim() };

  return value.includes('@') ? { email: value } : { name: value };
};
